// Maps server FormCode -> client route, and ParentGroup -> display label.
// The sidebar is data-driven off the user's permission set; this registry only
// supplies the route path + group label the DB doesn't carry.

export const FORM_ROUTES = {
  DASHBOARD: '/dashboard',
  ACCOUNT_CODE: '/account-codes',
  CURRENCY: '/currencies',
  NATIONALITY: '/nationalities',
  CUSTOMER: '/customers',
  BENEFICIARY: '/beneficiaries',
  PARTNER: '/partners',
  BANK_UMUM: '/bank-umum',
  BANK_ACCOUNT: '/bank-accounts',
  EXPENSE_TYPE: '/expense-types',
  INCOME_TYPE: '/income-types',
  BUY_SELL: '/transactions/buy-sell',
  REMITTANCE: '/transactions/remittance',
  TRANSFER: '/transactions/transfer',
  BIAYA: '/transactions/expense',
  PENDAPATAN: '/transactions/income',
  UPLOAD: '/transactions/upload',
  UPLOAD_DOCUMENT: '/transactions/upload-document',
  MONTHLY_CLOSING: '/transactions/monthly-closing',
  REPORT_BUY_SELL: '/reports/buy-sell',
  REPORT_BANK: '/reports/bank',
  REPORT_EXPENSE_INCOME: '/reports/expense-income',
  REPORT_PROFIT_LOSS: '/reports/profit-loss',
  REPORT_CURRENCY_BALANCE: '/reports/currency-balance',
  SETTINGS: '/settings',
};

export const GROUP_LABELS = {
  MASTER_DATA: 'Master Data',
  TRANSACTIONS: 'Transactions',
  REPORTS: 'Reports',
};

export function groupLabel(code) {
  return GROUP_LABELS[code] || code;
}
